import React, { useContext } from "react";
import { useRouter } from 'next/router'; 
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { makeStyles } from"@mui/styles";
import useScreenSize from "../../components/customHooks/useScreenSize";
import { useAuth } from "components/context/auth";
import { GlobalContext } from "../context/GlobalContext";

const HowItWorks = (props) => {
  const screenSize = useScreenSize();
  const classes = useStyles();
  const router = useRouter();
  const { user } = useAuth();
  const { toggleModal, setModal } = useContext(GlobalContext);

  const handleCreateTeamClick = () => {
    if (user) {
      router.push('/profile');
    } else {
      setModal('login');
      toggleModal();
    }
  };

  const handleJoinTeamClick = () => {
    if (user) {
      router.push('/search?term=&team=true');
    } else {
      setModal("login");
      toggleModal();
    }
  };

  const handleFindTeammatesClick = () => {
    if (user) {
      router.push('/search?term=&user=true');
    } else {
      setModal("login");
      toggleModal();
    }
  };

  return (
    <section ref={props.howItWorksRef}>
      <div style={{ position: "absolute" }} id="howitworks">
        <svg
          width="260"
          height="428"
          viewBox="0 0 260 428"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="57"
            cy="203"
            r="163"
            stroke="url(#paint0_linear)"
            strokeWidth="80"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M96.3179 377.386C96.3179 378.491 95.4224 379.386 94.3179 379.386C93.2133 379.386 92.3179 378.491 92.3179 377.386C92.3179 376.282 93.2133 375.386 94.3179 375.386C95.4224 375.386 96.3179 376.282 96.3179 377.386ZM94.3179 395.386C95.4224 395.386 96.3179 394.491 96.3179 393.386C96.3179 392.282 95.4224 391.386 94.3179 391.386C93.2133 391.386 92.3179 392.282 92.3179 393.386C92.3179 394.491 93.2133 395.386 94.3179 395.386ZM110.318 395.386C111.422 395.386 112.318 394.491 112.318 393.386C112.318 392.282 111.422 391.386 110.318 391.386C109.213 391.386 108.318 392.282 108.318 393.386C108.318 394.491 109.213 395.386 110.318 395.386ZM128.318 393.386C128.318 394.491 127.422 395.386 126.318 395.386C125.213 395.386 124.318 394.491 124.318 393.386C124.318 392.282 125.213 391.386 126.318 391.386C127.422 391.386 128.318 392.282 128.318 393.386ZM142.318 395.386C143.422 395.386 144.318 394.491 144.318 393.386C144.318 392.282 143.422 391.386 142.318 391.386C141.213 391.386 140.318 392.282 140.318 393.386C140.318 394.491 141.213 395.386 142.318 395.386ZM160.318 393.386C160.318 394.491 159.422 395.386 158.318 395.386C157.213 395.386 156.318 394.491 156.318 393.386C156.318 392.282 157.213 391.386 158.318 391.386C159.422 391.386 160.318 392.282 160.318 393.386ZM174.318 395.386C175.422 395.386 176.318 394.491 176.318 393.386C176.318 392.282 175.422 391.386 174.318 391.386C173.213 391.386 172.318 392.282 172.318 393.386C172.318 394.491 173.213 395.386 174.318 395.386ZM110.318 379.386C111.422 379.386 112.318 378.491 112.318 377.386C112.318 376.282 111.422 375.386 110.318 375.386C109.213 375.386 108.318 376.282 108.318 377.386C108.318 378.491 109.213 379.386 110.318 379.386ZM128.318 377.386C128.318 378.491 127.422 379.386 126.318 379.386C125.213 379.386 124.318 378.491 124.318 377.386C124.318 376.282 125.213 375.386 126.318 375.386C127.422 375.386 128.318 376.282 128.318 377.386ZM142.318 379.386C143.422 379.386 144.318 378.491 144.318 377.386C144.318 376.282 143.422 375.386 142.318 375.386C141.213 375.386 140.318 376.282 140.318 377.386C140.318 378.491 141.213 379.386 142.318 379.386ZM160.318 377.386C160.318 378.491 159.422 379.386 158.318 379.386C157.213 379.386 156.318 378.491 156.318 377.386C156.318 376.282 157.213 375.386 158.318 375.386C159.422 375.386 160.318 376.282 160.318 377.386ZM174.318 379.386C175.422 379.386 176.318 378.491 176.318 377.386C176.318 376.282 175.422 375.386 174.318 375.386C173.213 375.386 172.318 376.282 172.318 377.386C172.318 378.491 173.213 379.386 174.318 379.386ZM96.3179 409.386C96.3179 410.491 95.4224 411.386 94.3179 411.386C93.2133 411.386 92.3179 410.491 92.3179 409.386C92.3179 408.282 93.2133 407.386 94.3179 407.386C95.4224 407.386 96.3179 408.282 96.3179 409.386ZM94.3179 427.386C95.4224 427.386 96.3179 426.491 96.3179 425.386C96.3179 424.282 95.4224 423.386 94.3179 423.386C93.2133 423.386 92.3179 424.282 92.3179 425.386C92.3179 426.491 93.2133 427.386 94.3179 427.386ZM110.318 427.386C111.422 427.386 112.318 426.491 112.318 425.386C112.318 424.282 111.422 423.386 110.318 423.386C109.213 423.386 108.318 424.282 108.318 425.386C108.318 426.491 109.213 427.386 110.318 427.386ZM128.318 425.386C128.318 426.491 127.422 427.386 126.318 427.386C125.213 427.386 124.318 426.491 124.318 425.386C124.318 424.282 125.213 423.386 126.318 423.386C127.422 423.386 128.318 424.282 128.318 425.386ZM142.318 427.386C143.422 427.386 144.318 426.491 144.318 425.386C144.318 424.282 143.422 423.386 142.318 423.386C141.213 423.386 140.318 424.282 140.318 425.386C140.318 426.491 141.213 427.386 142.318 427.386ZM160.318 425.386C160.318 426.491 159.422 427.386 158.318 427.386C157.213 427.386 156.318 426.491 156.318 425.386C156.318 424.282 157.213 423.386 158.318 423.386C159.422 423.386 160.318 424.282 160.318 425.386ZM174.318 427.386C175.422 427.386 176.318 426.491 176.318 425.386C176.318 424.282 175.422 423.386 174.318 423.386C173.213 423.386 172.318 424.282 172.318 425.386C172.318 426.491 173.213 427.386 174.318 427.386ZM110.318 411.386C111.422 411.386 112.318 410.491 112.318 409.386C112.318 408.282 111.422 407.386 110.318 407.386C109.213 407.386 108.318 408.282 108.318 409.386C108.318 410.491 109.213 411.386 110.318 411.386ZM128.318 409.386C128.318 410.491 127.422 411.386 126.318 411.386C125.213 411.386 124.318 410.491 124.318 409.386C124.318 408.282 125.213 407.386 126.318 407.386C127.422 407.386 128.318 408.282 128.318 409.386ZM142.318 411.386C143.422 411.386 144.318 410.491 144.318 409.386C144.318 408.282 143.422 407.386 142.318 407.386C141.213 407.386 140.318 408.282 140.318 409.386C140.318 410.491 141.213 411.386 142.318 411.386ZM160.318 409.386C160.318 410.491 159.422 411.386 158.318 411.386C157.213 411.386 156.318 410.491 156.318 409.386C156.318 408.282 157.213 407.386 158.318 407.386C159.422 407.386 160.318 408.282 160.318 409.386ZM174.318 411.386C175.422 411.386 176.318 410.491 176.318 409.386C176.318 408.282 175.422 407.386 174.318 407.386C173.213 407.386 172.318 408.282 172.318 409.386C172.318 410.491 173.213 411.386 174.318 411.386Z"
            fill="#001B11"
          />
          <defs>
            <linearGradient
              id="paint0_linear"
              x1="249"
              y1="-45"
              x2="-37"
              y2="445"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#F5F4F2" />
              <stop offset="1" stopColor="#F5F4F2" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <Container
        style={{ paddingTop: screenSize === "largeScreen" ? "7rem" : "4rem" }}
      >
        {screenSize !== "largeScreen" && (
          <Typography align="center" className={classes.sectionTitle}>
            How It Works?
          </Typography>
        )}
        <Grid
          container
          direction="column"
          justifyContent="space-around"
          alignItems="center"
          spacing={2}
        >
          <Grid item>
            <Box mb={10}>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={3}
              >
                <Grid item xs={12} lg={4}>
                <div 
                    className={`how-it-works-card ${classes.clickable}`}
                    onClick={handleCreateTeamClick}
                    role="button"
                    tabIndex={0}
                  >
                    <svg
                      width="125"
                      height="104"
                      viewBox="0 0 125 104"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0"
                        mask-type="alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="125"
                        height="104"
                      >
                        <path
                          d="M0 12C0 5.37259 5.37258 0 12 0H125V104H0V12Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask0)">
                        <path
                          d="M100.5 63.403C122 45.4863 134 18.903 114 -1.59702L-51 -41L-67 84.5C-37.3333 82.5 8.78217 120.839 28 95C51.5 63.403 75.9 83.903 100.5 63.403Z"
                          fill="#F8C22B"
                        />
                        <path
                          d="M36.8442 28.7888H76.0424V43.0706H78.2201V22.1972C78.2201 21.6145 77.9906 21.0556 77.5823 20.6435C77.1739 20.2315 76.62 20 76.0424 20H36.8442C36.2666 20 35.7127 20.2315 35.3043 20.6435C34.8959 21.0556 34.6665 21.6145 34.6665 22.1972V52.958C34.6665 53.5407 34.8959 54.0996 35.3043 54.5116C35.7127 54.9237 36.2666 55.1552 36.8442 55.1552H60.7986V52.958H36.8442V28.7888ZM76.0424 22.1972V26.5916H36.8442V22.1972H76.0424ZM39.0219 24.3944C39.0219 24.1771 39.0857 23.9647 39.2054 23.784C39.325 23.6034 39.4951 23.4626 39.694 23.3794C39.893 23.2963 40.1119 23.2745 40.3231 23.3169C40.5343 23.3593 40.7283 23.4639 40.8806 23.6176C41.0329 23.7712 41.1366 23.967 41.1786 24.1801C41.2206 24.3932 41.1991 24.6141 41.1167 24.8148C41.0342 25.0156 40.8947 25.1871 40.7156 25.3078C40.5366 25.4286 40.3261 25.493 40.1107 25.493C39.8219 25.493 39.545 25.3773 39.3408 25.1712C39.1366 24.9652 39.0219 24.6858 39.0219 24.3944ZM74.9536 51.354L78.2201 50.5191V47.8055L62.7041 41.7852L60.6135 43.8945L66.5804 59.5496H69.2698L70.0973 56.2538L73.8647 60L78.6665 55.1552L74.9536 51.354ZM68.9649 51.9033L67.7672 56.5394L63.1614 44.4548L63.2485 44.3669L75.2258 49.014L70.5982 50.1675L75.596 55.1552L73.8647 56.902L68.9649 51.9033ZM43.3772 41.972C42.7997 41.972 42.2458 42.2035 41.8374 42.6155C41.429 43.0276 41.1995 43.5865 41.1995 44.1692V48.5636C41.1995 49.1463 41.429 49.7052 41.8374 50.1172C42.2458 50.5293 42.7997 50.7608 43.3772 50.7608H47.7326C48.3101 50.7608 48.864 50.5293 49.2724 50.1172C49.6808 49.7052 49.9103 49.1463 49.9103 48.5636V44.1692C49.9103 43.5865 49.6808 43.0276 49.2724 42.6155C48.864 42.2035 48.3101 41.972 47.7326 41.972H43.3772ZM43.3772 48.5636V44.1692H47.7326V48.5636H43.3772ZM70.5982 36.479H52.0879V34.2818H70.5982V36.479ZM52.0879 45.2678H58.621V47.465H52.0879V45.2678ZM51.8375 31.6891L46.0667 38.6762H43.889L41.3846 35.5122L43.0832 34.15L45.0431 36.479L50.1607 30.2829L51.8375 31.6891ZM43.3772 24.3944C43.3772 24.1771 43.4411 23.9647 43.5607 23.784C43.6804 23.6034 43.8504 23.4626 44.0494 23.3794C44.2483 23.2963 44.4673 23.2745 44.6785 23.3169C44.8897 23.3593 45.0837 23.4639 45.236 23.6176C45.3883 23.7712 45.492 23.967 45.534 24.1801C45.576 24.3932 45.5544 24.6141 45.472 24.8148C45.3896 25.0156 45.25 25.1871 45.071 25.3078C44.8919 25.4286 44.6814 25.493 44.4661 25.493C44.1773 25.493 43.9003 25.3773 43.6961 25.1712C43.4919 24.9652 43.3772 24.6858 43.3772 24.3944Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                    <Box m={3}>
                      <Typography
                        variant="h5"
                        align="left"
                        sx={{
                          fontFamily: "Poppins",
                          fontWeight: "bold",
                          position: "relative",
                          top: "-6px",
                          letterSpacing: ".15px",
                          fontSize: "24px",
                          display: "inline",
                        }}
                      >
                        Create a Team
                      </Typography>
                      <Box mt={2}>
                        <Typography align="left">
                          <span
                            style={{
                              lineHeight: "27px",
                              letterSpacing: ".15px",
                              position: "relative",
                              top: "-4px",
                              color: "#001B11BB",
                              fontSize: "18px",
                            }}
                          >
                            Making a team is easy. To start a team, specify your
                            team’s mission. Then invite teammates. Build Teams,
                            Achieve Goals!
                          </span>
                        </Typography>
                      </Box>
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={12} lg={4}>
                <div 
                  className={`how-it-works-card ${classes.clickable}`}
                  onClick={handleJoinTeamClick}
                  role="button"
                  tabIndex={0}
                >
                    <svg
                      width="125"
                      height="104"
                      viewBox="0 0 125 104"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0"
                        mask-type="alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="125"
                        height="104"
                      >
                        <path
                          d="M0 12C0 5.37259 5.37258 0 12 0H125V104H0V12Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask0)">
                        <path
                          d="M100.5 63.403C122 45.4863 134 18.903 114 -1.59702L-51 -41L-67 84.5C-37.3333 82.5 8.78217 120.839 28 95C51.5 63.403 75.9 83.903 100.5 63.403Z"
                          fill="#2eb790"
                        />
                        <path
                          d="M40.6333 28.755C41.2086 28.7876 41.7842 28.6968 42.3225 28.4885C42.8608 28.2802 43.3496 27.9591 43.7571 27.5462C44.1645 27.1333 44.4814 26.638 44.6869 26.0925C44.8925 25.547 44.9821 24.9637 44.95 24.3808C44.9821 23.7978 44.8925 23.2145 44.6869 22.669C44.4814 22.1235 44.1645 21.6282 43.7571 21.2153C43.3496 20.8024 42.8608 20.4814 42.3225 20.273C41.7842 20.0647 41.2086 19.9739 40.6333 20.0065C40.058 19.9739 39.4824 20.0647 38.9441 20.273C38.4059 20.4814 37.917 20.8024 37.5096 21.2153C37.1022 21.6282 36.7853 22.1235 36.5797 22.669C36.3742 23.2145 36.2845 23.7978 36.3167 24.3808C36.2845 24.9637 36.3742 25.547 36.5797 26.0925C36.7853 26.638 37.1022 27.1333 37.5096 27.5462C37.917 27.9591 38.4059 28.2802 38.9441 28.4885C39.4824 28.6968 40.058 28.7876 40.6333 28.755V28.755ZM40.6333 22.5061C40.8834 22.4759 41.137 22.5037 41.375 22.5872C41.613 22.6708 41.8292 22.8079 42.0073 22.9884C42.1854 23.1689 42.3208 23.388 42.4032 23.6291C42.4857 23.8703 42.5131 24.1273 42.4833 24.3808C42.5131 24.6342 42.4857 24.8912 42.4032 25.1324C42.3208 25.3735 42.1854 25.5926 42.0073 25.7731C41.8292 25.9536 41.613 26.0907 41.375 26.1743C41.137 26.2578 40.8834 26.2856 40.6333 26.2554C40.3832 26.2856 40.1296 26.2578 39.8916 26.1743C39.6536 26.0907 39.4374 25.9536 39.2593 25.7731C39.0812 25.5926 38.9459 25.3735 38.8634 25.1324C38.781 24.8912 38.7536 24.6342 38.7833 24.3808C38.7536 24.1273 38.781 23.8703 38.8634 23.6291C38.9459 23.388 39.0812 23.1689 39.2593 22.9884C39.4374 22.8079 39.6536 22.6708 39.8916 22.5872C40.1296 22.5037 40.3832 22.4759 40.6333 22.5061V22.5061ZM35.7 37.5036H33.2333V36.2538C33.2333 32.4045 36.07 30.0048 40.6333 30.0048C45.1967 30.0048 48.0333 32.4045 48.0333 36.2538V37.5036H45.5667V36.2538C45.5667 33.1543 42.8903 32.5044 40.6333 32.5044C38.3763 32.5044 35.7 33.1543 35.7 36.2538V37.5036ZM72.7 28.755C73.2753 28.7876 73.8509 28.6968 74.3892 28.4885C74.9275 28.2802 75.4163 27.9591 75.8237 27.5462C76.2312 27.1333 76.548 26.638 76.7536 26.0925C76.9592 25.547 77.0488 24.9637 77.0167 24.3808C77.0488 23.7978 76.9592 23.2145 76.7536 22.669C76.548 22.1235 76.2312 21.6282 75.8237 21.2153C75.4163 20.8024 74.9275 20.4814 74.3892 20.273C73.8509 20.0647 73.2753 19.9739 72.7 20.0065C72.1247 19.9739 71.5491 20.0647 71.0108 20.273C70.4725 20.4814 69.9837 20.8024 69.5763 21.2153C69.1688 21.6282 68.852 22.1235 68.6464 22.669C68.4408 23.2145 68.3512 23.7978 68.3833 24.3808C68.3512 24.9637 68.4408 25.547 68.6464 26.0925C68.852 26.638 69.1688 27.1333 69.5763 27.5462C69.9837 27.9591 70.4725 28.2802 71.0108 28.4885C71.5491 28.6968 72.1247 28.7876 72.7 28.755V28.755ZM72.7 22.5061C72.9501 22.4759 73.2037 22.5037 73.4417 22.5872C73.6797 22.6708 73.8959 22.8079 74.074 22.9884C74.2521 23.1689 74.3875 23.388 74.4699 23.6291C74.5524 23.8703 74.5797 24.1273 74.55 24.3808C74.55 24.878 74.3551 25.3548 74.0081 25.7064C73.6612 26.0579 73.1907 26.2554 72.7 26.2554C72.2094 26.2554 71.7388 26.0579 71.3919 25.7064C71.0449 25.3548 70.85 24.878 70.85 24.3808C70.8203 24.1273 70.8476 23.8703 70.9301 23.6291C71.0125 23.388 71.1479 23.1689 71.326 22.9884C71.5041 22.8079 71.7203 22.6708 71.9583 22.5872C72.1963 22.5037 72.4499 22.4759 72.7 22.5061V22.5061ZM67.7667 37.5036H65.3V36.2538C65.3 32.4045 68.1367 30.0048 72.7 30.0048C77.2633 30.0048 80.1 32.4045 80.1 36.2538V37.5036H77.6333V36.2538C77.6333 33.1543 74.957 32.5044 72.7 32.5044C70.443 32.5044 67.7667 33.1543 67.7667 36.2538V37.5036ZM49.2667 42.5028H32V40.0032H49.2667V42.5028ZM81.3333 40.0032V42.5028H64.0667V40.0032H81.3333ZM56.6667 40.0032C62.0933 40.0032 64.0667 35.1415 64.0667 31.8795C64.0667 28.6176 62.0933 23.7559 56.6667 23.7559C51.24 23.7559 49.2667 28.6176 49.2667 31.8795C49.2667 35.1415 51.24 40.0032 56.6667 40.0032ZM56.6667 26.2554C61.6 26.2554 61.6 31.6546 61.6 31.8795C61.6 32.1045 61.6 37.5036 56.6667 37.5036C51.7333 37.5036 51.7333 32.1045 51.7333 31.8795C51.7333 31.6546 51.795 26.2554 56.6667 26.2554ZM69 51.6888V60H66.5333V51.6888C66.5333 47.1021 61.415 45.0024 56.6667 45.0024C51.9183 45.0024 46.8 47.1021 46.8 51.6888V60H44.3333V51.6888C44.3333 45.3774 50.722 42.5028 56.6667 42.5028C62.6113 42.5028 69 45.3774 69 51.6888Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                    <Box m={3}>
                      <Typography
                        variant="h5"
                        align="left"
                        sx={{
                          fontFamily: "Poppins",
                          fontWeight: "bold",
                          position: "relative",
                          top: "-6px",
                          letterSpacing: ".15px",
                        }}
                      >
                        Join a Team
                      </Typography>
                      <Box mt={2}>
                        <Typography align="left">
                          <span
                            style={{
                              lineHeight: "27px",
                              letterSpacing: ".15px",
                              position: "relative",
                              top: "-4px",
                              color: "#001B11BB",
                              fontSize: "18px",
                            }}
                          >
                            Are you looking to be part of something bigger? Use
                            TeammateMe to
                            find teams that interest you and apply to join them.
                          </span>
                        </Typography>
                      </Box>
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={12} lg={4}>
                <div 
                  className={`how-it-works-card ${classes.clickable}`}
                  onClick={handleFindTeammatesClick}
                  role="button"
                  tabIndex={0}
                >
                    <svg
                      width="125"
                      height="104"
                      viewBox="0 0 125 104"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0"
                        mask-type="alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="125"
                        height="104"
                      >
                        <path
                          d="M0 12C0 5.37259 5.37258 0 12 0H125V104H0V12Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask0)">
                        <path
                          d="M100.5 63.403C122 45.4863 134 18.903 114 -1.59702L-51 -41L-67 84.5C-37.3333 82.5 8.78217 120.839 28 95C51.5 63.403 75.9 83.903 100.5 63.403Z"
                          fill="#E67C89"
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M69.3667 38.2484C69.3667 46.1251 63.0091 52.4968 55.1834 52.4968C47.3577 52.4968 41 46.1251 41 38.2484C41 30.3717 47.3577 24 55.1834 24C63.0091 24 69.3667 30.3717 69.3667 38.2484ZM64.7541 51.3522C62.0736 53.3291 58.7643 54.4968 55.1834 54.4968C46.2455 54.4968 39 47.2221 39 38.2484C39 29.2747 46.2455 22 55.1834 22C64.1212 22 71.3667 29.2747 71.3667 38.2484C71.3667 42.8221 69.4845 46.9545 66.4554 49.9072L73 56.4741L71.3793 58L64.7541 51.3522ZM55.1834 37.7593C55.7552 37.7923 56.3274 37.7003 56.8625 37.4893C57.3976 37.2784 57.8835 36.9532 58.2886 36.5351C58.6936 36.117 59.0086 35.6154 59.2129 35.063C59.4172 34.5106 59.5064 33.9199 59.4744 33.3295C59.5064 32.7392 59.4172 32.1485 59.2129 31.5961C59.0086 31.0437 58.6936 30.5421 58.2886 30.124C57.8835 29.7059 57.3976 29.3807 56.8625 29.1698C56.3274 28.9588 55.7552 28.8668 55.1834 28.8998C54.6115 28.8668 54.0393 28.9588 53.5042 29.1698C52.9691 29.3807 52.4832 29.7059 52.0782 30.124C51.6732 30.5421 51.3582 31.0437 51.1538 31.5961C50.9495 32.1485 50.8604 32.7392 50.8923 33.3295C50.8604 33.9199 50.9495 34.5106 51.1538 35.063C51.3582 35.6154 51.6732 36.117 52.0782 36.5351C52.4832 36.9532 52.9691 37.2784 53.5042 37.4893C54.0393 37.7003 54.6115 37.7923 55.1834 37.7593ZM55.1834 31.4311C55.432 31.4006 55.6841 31.4287 55.9207 31.5133C56.1572 31.5979 56.3722 31.7368 56.5492 31.9196C56.7262 32.1023 56.8608 32.3242 56.9428 32.5684C57.0247 32.8126 57.052 33.0729 57.0224 33.3295C57.052 33.5862 57.0247 33.8464 56.9428 34.0907C56.8608 34.3349 56.7262 34.5568 56.5492 34.7395C56.3722 34.9223 56.1572 35.0612 55.9207 35.1458C55.6841 35.2304 55.432 35.2585 55.1834 35.228C54.9347 35.2585 54.6826 35.2304 54.4461 35.1458C54.2095 35.0612 53.9946 34.9223 53.8175 34.7395C53.6405 34.5568 53.5059 34.3349 53.424 34.0907C53.342 33.8464 53.3148 33.5862 53.3443 33.3295C53.3148 33.0729 53.342 32.8126 53.424 32.5684C53.5059 32.3242 53.6405 32.1023 53.8175 31.9196C53.9946 31.7368 54.2095 31.5979 54.4461 31.5133C54.6826 31.4287 54.9347 31.4006 55.1834 31.4311ZM50.2793 46.6188H47.8273V45.3531C47.8273 41.455 50.6471 39.0249 55.1834 39.0249C59.7196 39.0249 62.5394 41.455 62.5394 45.3531V46.6188H60.0874V45.3531C60.0874 42.2143 57.427 41.5562 55.1834 41.5562C52.9398 41.5562 50.2793 42.2143 50.2793 45.3531V46.6188Z"
                        fill="white"
                      />
                    </svg>
                    <Box m={3}>
                      <Typography variant="h5" align="left">
                        <span
                          style={{
                            fontFamily: "Poppins",
                            fontWeight: "bold",
                            position: "relative",
                            top: "-6px",
                            letterSpacing: ".15px",
                            display: "inline",
                          }}
                        >
                          Find Teammates
                        </span>
                      </Typography>
                      <Box mt={2}>
                        <Typography align="left">
                          <span
                            style={{
                              lineHeight: "27px",
                              letterSpacing: ".15px",
                              position: "relative",
                              top: "-4px",
                              color: "#001B11BB",
                              fontSize: "18px",
                            }}
                          >
                            Together, we accomplish more! Find the most relevant
                            teammates with the right skills, interests, and
                            reputation scores.
                          </span>
                        </Typography>
                      </Box>
                    </Box>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
};

export default HowItWorks;

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontSize: "28px",
    // @TODO update font weight to 600
    fontWeight: 700,
    marginBottom: "2rem",
    position: "relative",
    zIndex: 200,
    [theme.breakpoints.down(400)]: {
      fontSize: "25px",
    },
  },
  clickable: {
    cursor: 'pointer',
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    },
  },
}));
